import React from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';
import Card from 'src/components/Cards/Card';
import Text from 'shared/components/text';
import Pill from 'src/components/Pill';
import CollegeTaggingCard from './college-tagging-card';

class CollegePopularTags extends React.Component {
  static propTypes = {
    popularTags: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        _id: PropTypes.string,
        group: PropTypes.string,
      })
    ),
    showTagButton: PropTypes.bool,
    college: PropTypes.shape({
      studentCollegeTags: PropTypes.arrayOf(
        PropTypes.shape({
          student_id: PropTypes.string,
          college_id: PropTypes.string,
          tag: PropTypes.shape({
            name: PropTypes.string,
            _id: PropTypes.string,
            group: PropTypes.string,
          }),
        })
      ),
    }),
  };

  renderPills = () => {
    const {
      popularTags,
      college: {studentCollegeTags},
    } = this.props;
    // popularTags shape: {name, _id, group}
    // studentCollegeTags shape: {student_id, college_id, tag:{name, _id, group}}
    const studentTags = studentCollegeTags ? studentCollegeTags : [];
    const uniqueTags = new Set([
      ...map(studentTags, (studentTag) => studentTag.tag.name),
      ...map(popularTags, (tag) => tag.name),
    ]);
    return map([...uniqueTags], (tagName) => <Pill key={`pill-${tagName}`}>{tagName}</Pill>);
  };

  renderHeader = () => (
    <Text header color="darkgrey" className="college-popular-tags-heading">
      Popular tags for this college
    </Text>
  );

  render() {
    const {showTagButton, college} = this.props;

    const renderedPills = this.renderPills();
    const showPopularTags = renderedPills.length > 0;

    return (
      (showPopularTags || showTagButton) && (
        <Card className="college-popular-tags">
          {showPopularTags && this.renderHeader()}
          {showPopularTags && renderedPills}
          {showTagButton && showPopularTags && <hr />}
          {showTagButton && <CollegeTaggingCard college={college} />}
        </Card>
      )
    );
  }
}

export default CollegePopularTags;
